import { ButtonStyled } from "./buttonStyled";
import { Icons } from "./../icons";
import { Tooltip } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";

export const Button = ({
  startIcon,
  endIcon,
  iconSize = 16,
  iconColor,
  onClick,
  label,
  type = "contained",
  buttonStyles,
  tooltipLabel,
  isLoading = false,
  fullWidth = false,
  containerStyles,
  isDisabled = false,
  className,
  ...rest
}) => {
  const StartIconComponent = Icons?.[startIcon];
  const EndIconComponent = Icons?.[endIcon];

  const buttonContent = (
    <div
      className={className}
      style={{
        display: "inline-block",
        width: fullWidth ? "100%" : "fit-content",
        ...containerStyles,
      }}
    >
      <ButtonStyled
        onClick={onClick}
        customType={type}
        sx={buttonStyles}
        disabled={isDisabled || isLoading}
        disableRipple
        {...rest}
      >
        {startIcon && (
          <StartIconComponent
            size={iconSize}
            color={iconColor}
            weight={"bold"}
          />
        )}
        {isLoading ? (
          <ClipLoader loading={true} size={16} color="#0197f6" />
        ) : (
          label && <span>{label}</span>
        )}
        {endIcon && (
          <EndIconComponent size={iconSize} color={iconColor} weight={"bold"} />
        )}
      </ButtonStyled>
    </div>
  );

  return tooltipLabel ? (
    <Tooltip
      title={tooltipLabel}
      arrow
      PopperProps={{
        style: { zIndex: 999999 },
      }}
    >
      {buttonContent}
    </Tooltip>
  ) : (
    buttonContent
  );
};
